import React, { useContext, useState } from 'react'
import cn from 'classnames'
import styles from './RemoveSale.module.sass'
import Loader from '../Loader'
import { message } from 'antd'
import { getContracts } from '../../adapters/eth'
import { Web3Context } from '../../contexts/Web3Context'
import Connect from '../Connect'
import SwitchNetwork from '../ConnectMetamask/SwitchNetwork'

message.config({ top: 100, duration: 5, maxCount: 3, })

const RemoveSale = ({ className, item, onOutsideClick }) => {

  const [inProcess, setInProcess] = useState(false)

  const { web3, defaultAccount, isConnected, isCorrectNetwork } = useContext(Web3Context)

  const cancelOnSale = async () => {
    try {
      const contracts = await getContracts(web3)

      setInProcess(true)
      contracts.Marketplace.methods.cancel(item.in_sale)
        .send({ from: defaultAccount })
        .once('receipt', () => {
          setInProcess(false)
          message.success('Done')
          window.location.reload()
        })
        .on('error', e => {
          console.log(e)
          message.error('Error on remove from sale!')
          setInProcess(false)
          return false
        })
    } catch (e) {
      console.log(e)
      message.error('Error on remove from sale!')
      setInProcess(false)
      return false
    }
  }

  return (
    <div className={cn(className, styles.transfer)}>
      {!isConnected && <Connect/>}
      {isConnected && isCorrectNetwork && <>
        <div className={cn('h4', styles.title)}>Remove from sale</div>
        <div className={styles.text}>
          Do you really want to remove your item from sale? You can put it on sale
          anytime
        </div>
        <div className={styles.btns}>

          <button className={cn('button', styles.button)} onClick={cancelOnSale}>
            {inProcess ?
              <Loader className={styles.loader} color="white"/> :
              'Remove now'
            }
          </button>
          <button className={cn('button-stroke', styles.button)} onClick={onOutsideClick}>Cancel</button>

        </div>
      </>}
      {isConnected && !isCorrectNetwork && <SwitchNetwork/>}
    </div>
  )
}

export default RemoveSale
